import React from "react";
import { Provider } from "react-redux";

import "./App.scss";

import { isMobile } from "react-device-detect";

import store from "./store";

import View from "./View";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { height: 512 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <div
        className={`wrapper ${isMobile ? "mobile" : ""}`}
        style={{ height: this.state.height }}
      >
        <Provider store={store}>
          <View />
        </Provider>
      </div>
    );
  }
}

export default App;
